import dayjs from "dayjs";
import { notice_update_terms } from "@/data/links";
import { mapActions } from "vuex";

const NEWS_NAME = "TERMS";
const START_DATE = dayjs("2023-04-03 00:00");
const END_DATE = dayjs("2023-04-30 23:59");
const CURRENT_DATE = dayjs();
const CONFIRM_LINK = notice_update_terms;
const IS_OUT_LINK = true;

export default {
    computed: {
        isInNewsPeriod() {
            return START_DATE <= CURRENT_DATE && CURRENT_DATE <= END_DATE;
        },
        isNewsChecked() {
            const checkedNewsName = localStorage.getItem("checkedNews");
            return checkedNewsName === NEWS_NAME;
        }
    },
    methods: {
        ...mapActions(["UPDATE_DIALOG"]),
        setNewsChecked() {
            localStorage.setItem("checkedNews", NEWS_NAME);
        },
        openNewsDialog() {
            this.UPDATE_DIALOG({
                hasCloseButton: true,
                isActionsCenter: true,
                slot: () => import("@/components/dialogs/news/Dialog.news.vue"),
                actions: [
                    {
                        async_action: "confirm",
                        label: this.$t("news.button"),
                        autofocus: true
                    }
                ],
                confirm: dialog => {
                    dialog.close();
                    if (IS_OUT_LINK) {
                        window.open(CONFIRM_LINK, "_blank");
                    } else {
                        this.$router.push(CONFIRM_LINK);
                    }
                    this.$nc({}, "pop.news");
                }
            });
        }
    }
};
